import React from 'react';
import { hot } from 'react-hot-loader';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import Slider from '../../hocs/Slider/Slider';
import Translate from '../../hocs/Translate/Translate';
import CountDown from './CountDown/CountDown';
import Media from './Media/Media';
import Text from './Text/Text';
import FreeHTML from './FreeHTML/FreeHTML';
import Products from './Products/Products';

import s from './TemplateParserDeprecated.scss';

const TemplateInner = ({ section, setup, list, staticText, country, canonical, magazine }) => {
	const standardAttributes = { setup, list, staticText, canonical, magazine };
	const sectionCSS = {
		textAlign: section.align.horizontal,
	};
	if (section.marginTop) sectionCSS.marginTop = `${section.marginTop}px`;
	if (section.marginBottom) sectionCSS.marginBottom = `${section.marginBottom}px`;
	if (section.styleBackgroundColor) sectionCSS.backgroundColor = section.styleBackgroundColor;
	if (section.styleContentColor) sectionCSS.color = section.styleContentColor;
	if (!section.column) return null;

	return (
		<div className={[s.section, (section.styleBackgroundColor ? s.section__backgroundColor : null)].join(' ')} style={sectionCSS}>
			{ section.id ? <Translate string="id" obj={section} createElement /> : null }
			{
				section.column.map((column) => {
					if (!column.template) return null;
					const components = {
						media: Media,
						text: Text,
						freeHtml: FreeHTML,
						products: Products,
						countDown: CountDown,
					};
					const Template = components[column.template];
					const columnCSS = {
						verticalAlign: section.align.vertical,
					};

					if (!list) {
						if (section.column.length > 1) {
							columnCSS.width = `calc(${column.width}% - ${(section.column.length - 1) * 12 / section.column.length}px)`;
						} else {
							columnCSS.width = `${column.width}%`;
						}
					}

					// Restrict content based on country
					if (column.restrictCountries && column.restrictCountries.indexOf(country.toUpperCase()) !== -1) return null;
					// Restrict content based on language
					if (column.restrictLanguages && column.restrictLanguages.indexOf(setup.language.toLowerCase()) !== -1) return null;

					return (
						<div key={column.key} className={[s.section_column, s[`section_column__${column.width}`]].join(' ')} style={columnCSS}>
							<ErrorBoundary message={`Column: ${JSON.stringify(column)}`}>
								<Template content={column[column.template]} columnWidth={column.width} {...standardAttributes} />
							</ErrorBoundary>
						</div>
					);
				})
			}
		</div>
	);
};

const TemplateParser = ({ sections, setup, list, currentPath = false, canonical = false, magazine = false, top = null, bottom = null }) => {
	if (!sections) return null;
	let slides = [];
	let emptySlides = false;
	const templateContents = [];
	const { country } = setup;
	const standardAttributes = { setup, country, list, canonical: (currentPath ? `${currentPath}/${canonical}` : false), magazine };

	sections.forEach((section, i) => { // eslint-disable-line consistent-return
		if (emptySlides) {
			slides = [];
			emptySlides = false;
		}

		if (top !== null || bottom !== null) {
			if (!top && section.aboveCategory) return null;
			if (!bottom && !section.aboveCategory) return null;
		}

		if (section.isSlide) {
			slides.push(<TemplateInner key={section.key} section={section} {...standardAttributes} />);
		}

		if (slides.length > 0) {
			if (!section.isSlide || sections.length === i + 1) {
				// Has slides and this section is not in slider or Last section create slider.
				emptySlides = true;
				templateContents.push(<Slider key={`${section.key}_slider`} infinite>{slides.map((slide) => slide)}</Slider>);
			}
		}

		if (!section.isSlide) {
			templateContents.push(<TemplateInner key={section.key} section={section} {...standardAttributes} />);
		}
	});

	return (
		<div className={[s.sections, list ? s[`sections__${list}`] : null].join(' ')}>
			{ templateContents }
		</div>
	);
};

export default hot(module)(TemplateParser);
